const Loader = () => (
    <div className="text-center lg:relative absolute lg:w-auto w-full top-24 lg:top-auto">
        <div className="inline-block w-[25px] h-[25px] border-2 border-solid border-gray012 border-t-transparent rounded-[100%] animate-spin"></div>
    </div>
);
export default Loader;
